import { AbstractTileProvider } from "./tiles.provider.abstract";
export class TileProvider extends AbstractTileProvider {
    constructor(provider, factory, enabled = true) {
        super(factory, enabled);
        this.factory.withMetrics(provider.metrics).withNamespace(provider.name);
        this._contentProvider = provider;
    }
    _fetchContent(tile, callback) {
        return this._contentProvider.fetchContent(tile, callback);
    }
}
//# sourceMappingURL=tiles.provider.js.map